import { render, staticRenderFns } from "./ReportsDownloadHistory.vue?vue&type=template&id=83f956e6&scoped=true&"
import script from "./ReportsDownloadHistory.vue?vue&type=script&lang=js&"
export * from "./ReportsDownloadHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReportsDownloadHistory.vue?vue&type=style&index=0&id=83f956e6&prod&scoped=true&lang=css&"
import style1 from "./ReportsDownloadHistory.vue?vue&type=style&index=1&id=83f956e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f956e6",
  null
  
)

export default component.exports